export default __webpack_public_path__ + "static/media/AvenirNext-Italic.cc1ca539.woff";